export const PUBLIC_PORTFOLIO_ROUTE_NAME = 'portfolio-slug';

export const PORTFOLIO_BANNER_WELCOME_TOOLTIP = 'portfolio:banner-welcome';
export const PORTFOLIO_BANNER_YOUR_PORTFOLIO_IS_VISIBLE_TOOLTIP = 'portfolio:banner-your-portfolio-is-visible';

export const publicFieldNames = Object.freeze({
  FIELD_PHONE_IS_PUBLIC: 'fieldPhoneIsPublic',
  FIELD_PUBLIC_EMAIL_IS_PUBLIC: 'fieldPublicEmailIsPublic',
  FIELD_LINKEDIN_SLUG_IS_PUBLIC: 'fieldLinkedinSlugIsPublic',
  FIELD_CALENDAR_LINK_IS_PUBLIC: 'fieldCalendarLinkIsPublic',
});

export const publicPortfolioPopUps = Object.freeze({
  CONFIRM_SEND_REQUEST: 'confirm-send-request',
  CONFIRM_CANCEL_REQUEST: 'confirm-cancel-request',
  CONFIRM_REMOVE_CONNECTION: 'confirm-remove-connection',
  CONFIRM_REMOVE_CONNECTION_LIST: 'confirm-remove-connection-list',
  CONFIRM_CANCEL_SUGGESTED_LIST: 'confirm-cancel-suggested-list',
});

export const EDIT_SECTION_EVENT_NAME = 'public-portfolio__edit-section';
